import { api } from './api';
import type { DataSourceHealth, SyncJobHistory, PageFreshness } from '../types/dataHealth.types';

export const dataHealthService = {
  /**
   * Get all data sources health for current tenant, optionally filtered by siteId
   */
  getDataSourcesHealth: async (siteId?: number): Promise<DataSourceHealth[]> => {
    const params = siteId ? { siteId } : {};
    const response = await api.get('/coreapi/health/sources', { params });
    // Handle both direct array and wrapped response
    return Array.isArray(response.data) ? response.data : (response.data.data || []);
  },

  /**
   * Get sync job history with optional filtering
   */
  getSyncHistory: async (params?: {
    sourceType?: string;
    limit?: number;
  }): Promise<SyncJobHistory[]> => {
    const response = await api.get('/health/sync-history', { params });
    // Handle both direct array and wrapped response
    return Array.isArray(response.data) ? response.data : (response.data.data || []);
  },

  /**
   * Trigger manual sync for a data source (admin only)
   */
  forceSyncDataSource: async (sourceType: string): Promise<void> => {
    await api.post('/health/force-sync', { sourceType });
  },

  /**
   * Get page-level freshness for specific page
   */
  getPageFreshness: async (pageId: number): Promise<PageFreshness[]> => {
    const response = await api.get(`/health/pages/${pageId}/freshness`);
    return response.data;
  }
};
